export default __webpack_public_path__ + "static/media/filter.dfa1c0e3.svg";